<template>
  <div class='dataContainer'> 
      <div class="row">   
        <div class="hidden-sm col-md-2" >            
            <CarBrandSideBar></CarBrandSideBar><br>
            <CarModelSideBar></CarModelSideBar><br>
            <CarYearSideBar></CarYearSideBar><br>
        </div>
        <div class="col-xs-12 col-md-10" > 
            <router-view></router-view>                       
        </div>        
      </div>      
  </div>
</template>

<script>
import { eventBus } from '../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  created: function () {            
   
  },
  mounted: function () {        
    
  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped>
   @media screen and (max-width: 359px) {  
      .smallSideBar {
        display: none;
      }
   } 
</style>



// WEBPACK FOOTER //
// Main.vue?bd7a9a92